/**
 * Retrieves environment variable values from preloaded configurations
 * @param {string} variableName - The name of the environment variable to retrieve
 * @returns {string|boolean|null} The environment variable value, converted to boolean if 'false', or null if not found
 */
export function getEnv(variableName) {
  const variable = window.__PRELOAD_CONFIGS__?.[variableName] ?? null;

  if (variable) {
    return variable === 'false' ? false : variable;
  }

  return null;
}

export function isAppLang(lang) {
  return getEnv('REACT_APP_LANGUAGE') === lang;
}
